import type { ApiCountry, ApiLocality, ApiPlace } from '@app/packages/api/v2/types/entities'

import { uppercaseFirstLetter } from './uppercaseFirstLetter'

export type PlaceLabelValue = {
  place: ApiPlace
  country?: { attributes?: Partial<ApiCountry['attributes']> } | null
  locality?: { attributes?: Partial<ApiLocality['attributes']> } | null
}

/** Тире не должно рвать название по строкам, а «городской округ» в подписи не нужен. */
export const processPlaceLabel = (label: string) => uppercaseFirstLetter(label.replace(/-/gi, '\u2011').replace(/^городской округ /i, ''))

export const placeLabel = (value: PlaceLabelValue) =>
  processPlaceLabel(value.locality?.attributes?.name ?? value.country?.attributes?.name ?? value.place.attributes.address)
